import { Button } from 'antd';
import { useAppDispatch } from 'app/store';
import { uiModel } from 'entities/ui';
import { ComponentModes, SubstitutionsTypes } from 'shared/enums';
import style from './index.module.scss';

interface IProps {
  substitutionType: SubstitutionsTypes;
  orgId: string;
}

export const ControlButton: React.FC<IProps> = ({ substitutionType, orgId }) => {
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(
      uiModel.Substitutions.actions.openSubstitutionControlDrawer({
        mode: ComponentModes.create,
        substitution: { type: substitutionType, id: orgId },
      }),
    );
  };

  return (
    <Button onClick={onClick} type="link" className={style.controlButton}>
      {substitutionType === SubstitutionsTypes.acting ? 'Назначить И. О.' : 'Назначить замещающего'}
    </Button>
  );
};
